<div mat-dialog-content>
    <div class="person-container-button">
        <button mat-icon-button (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <p class="title">Listado de Clientes</p>
    <div class="person-form">
        <select [(ngModel)]="countryId" class="form-control" (change)="getCustomer()">
            <option class="ligthColor" value="0">Seleccione un pais</option>
            <option *ngFor="let c of countryList" value="{{c.id}}">{{c.name}}</option>
        </select>
    </div>
    <table class="person-table" mat-table [dataSource]="dataSource" #table>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let item">{{item.description}}</td>
        </ng-container>
        <ng-container matColumnDef="asignar">
            <th mat-header-cell *matHeaderCellDef>Asignar</th>
            <td mat-cell *matCellDef="let item">
                <div class="person-container-checkbox" matRipple [matRippleCentered]="true" [matRippleRadius]="40">
                    <div class="person-checkbox">
                        <input [id]="item.id" type="checkbox" [checked]="item.active" (click)="checked($event.srcElement,item.id)">
                        <label class="person-label" [for]="item.id">
                            <mat-icon>done</mat-icon>
                        </label>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
</div>